import jwt from 'jsonwebtoken';

export const SINGLE_REQUEST_DEFAULT_TIMEOUT = 5;

export default function generateSingleActionToken(
	sessionToken,
	metroidAccountId,
	requestTimeout = SINGLE_REQUEST_DEFAULT_TIMEOUT
) {
	const options = {
		expiresIn: `${requestTimeout}s`
	};

	const tokenPayload = {
		metroid_account_id: {
			brand: metroidAccountId.brand,
			business_unit: metroidAccountId.businessUnit,
			user_id: metroidAccountId.userId
		},
		reference_key: sessionToken.referenceKey
	};

	return jwt.sign(tokenPayload, sessionToken.secret, options);
}
